import { ca } from '@cian/analytics';

export function trackLinkOwnerClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'FeedBackForm',
    action: 'Click',
    label: 'ObjectDuplicates',
  });
}
